import React, { useState, useEffect } from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";
import axios from "axios";
import { IoIosAdd, IoIosArrowBack } from "react-icons/io";
import Header3 from "./components/Header3";
import ClipLoader from "react-spinners/ClipLoader";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";

const Smscampaign = (props) => {
  const history = useHistory();
  const businessid = localStorage.getItem("businessid");
  const textid = localStorage.getItem("textid");
  const alias = props.location.state.alias;
  const audience = props.location.state.audience;
  useEffect(() => {
    document.title = "Finalize marketing";
  });

  const [loadLabel, setLoadLabel] = useState(true);
  const [loadCliper, setLoadCliper] = useState(false);

  function next() {
    setLoadLabel(false);
    setLoadCliper(true);
  }

  if (localStorage.getItem("businessid") === null) {
    return <Redirect to="/login" />;
  } else {
    if (localStorage.getItem("textid") === null) {
      return <Redirect to="/sms" />;
    }
  }

  return (
    <div className="view">
      <Header3 />
      <form
        action="https://www.payfast.co.za/eng/process"
        name="form_a54ad269093bbef584e1bd2cfe93c8cf"
      >
        <div className="container">
          <div className="row justify-content-center just-container-insid">
            <div className="col-lg-7 mt-5 pl-0 pr-0">
              <div className=" BoxDashboardContainer mt-0 mb-4 mrgin-search pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-4 col-6 pl-0">
                      <button
                        type="button"
                        onClick={() => history.goBack()}
                        className="link-btn"
                      >
                        <IoIosArrowBack size={25} />
                        Back &nbsp;
                      </button>
                    </div>

                    <div className="col-lg-8 col-6 text-right">
                      <label className=" pt-2">
                        <span>Marketing</span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div className=" BoxDashboardContainer mb-5 pl-1 pr-1">
                <div className="row align-self-center justify-content-center">
                  <div className="item-top-header">
                    <div className="col-lg-12 col-10 col-sm-11">
                      <label className=" pt-2">
                        <span>SMS marketing</span>
                      </label>
                      <label class="back-arrow float-right">
                        <button
                          type="submit"
                          class={
                            props.location.state.cost < 100
                              ? "btn-disabled text-bold"
                              : "save-btn"
                          }
                          disabled={
                            props.location.state.cost < 100 ? true : false
                          }
                        >
                          {!loadCliper && (
                            <>
                              Pay R
                              {Number(props.location.state.cost).toFixed(2)}
                            </>
                          )}
                          {loadCliper && (
                            <ClipLoader
                              color={"#fff"}
                              loading={true}
                              size={20}
                            />
                          )}
                        </button>
                      </label>
                    </div>
                  </div>
                  {props.location.state.cost < 50 ? (
                    <div className="col-12 color-red">
                      Payments below R100.00 cannot be processed.
                    </div>
                  ) : (
                    ""
                  )}

                  <div className="h-divider w-100"></div>
                  <div className="col-12 text-left mb-2">
                    <span>
                      Text message
                      {/* {businessid}&textid={textid}&alias={alias}&audience={audience} */}
                    </span>
                  </div>

                  <div className={"item-select-active"}>
                    <div className="w-100 menu-links">
                      <div className="col-12 text-left">
                        <label className="pre-line font-normal">
                          {props.location.state.text}
                        </label>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <input required type="hidden" name="cmd" value="_paynow" />
        <input
          required
          type="hidden"
          name="receiver"
          pattern="[0-9]"
          value="15455113"
        />
        <input
          type="hidden"
          name="email_address"
          value={props.location.state.business_email}
        />

        <input
          type="hidden"
          name="m_payment_id"
          value={"marketing_" + textid}
        />

        <input type="hidden" name="custom_str1" value={textid} />

        <input type="hidden" name="custom_str2" value={audience} />

        <input type="hidden" name="custom_str3" value={alias} />

        <input type="hidden" name="custom_str4" value={businessid} />

        <input
          type="hidden"
          name="return_url"
          value="https://karamale.com/sms-marketing-response"
        />
        <input
          type="hidden"
          name="cancel_url"
          value="https://karamale.com/sms-marketing-cancel"
        />
        <input
          type="hidden"
          name="notify_url"
          value={`https://karamale.com/apps/kscanner/webservices.php?query=NOTIFY-URL-SMS-MARKETING`}
        />
        <input
          required
          id="PayFastAmount"
          type="hidden"
          step=".01"
          name="amount"
          min={Number(props.location.state.cost).toFixed(2)}
          max={Number(props.location.state.cost).toFixed(2)}
          placeholder={Number(props.location.state.cost).toFixed(2)}
          value={Number(props.location.state.cost).toFixed(2)}
          // value={5.0}
        />

        <input
          required
          type="hidden"
          name="item_name"
          maxlength="255"
          value="sms marketing"
        />
        <input
          type="hidden"
          name="item_description"
          maxlength="255"
          value="SMS Marketing is a direct and effective way to reach customers via text messages on Karamale"
        />
      </form>
    </div>
  );
};

export default Smscampaign;
